<template>
  <div>
    <a-form :form="form" @submit="addPermission">
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">Name of Permission</h4>
          <a-input
            v-decorator="['name', {initialValue: `${permission.name.split('-').join(' ')}`, rules: [{ required: true, message: 'Please enter the name of this permission' }] }]"
            class="custom-input"
            @ended="setSlug"
            placeholder="What is the Name of this User"
          />
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">Service</h4>
          <a-select
            v-decorator="[
            'service',
            {initialValue: permission.service, rules: [{ required: true, message: 'Please select a status' }] },
            ]"
            placeholder="What Service is this Permission for?"
          >
            <a-select-option
              :value="service.alias"
              :key="index"
              v-for="(service,index) in services"
            >{{service.name}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">
            Permission Status
            <sup>optional</sup>
          </h4>
          <a-select
            v-decorator="[
            'status',
            {initialValue: permission.active ? permission.active : 1, rules: [{ required: true, message: 'Please select a status' }] },
            ]"
            placeholder="Set Status for Permission"
          >
            <a-select-option :value="1">
              <a-badge status="success"/>Active
            </a-select-option>
            <a-select-option :value="0">
              <a-badge status="error"/>InActive
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">
            Permission Description
            <sup>optional</sup>
          </h4>
          <a-textarea
            v-decorator="['description', {initialValue: permission.description, rules: [{ message: 'Please Enter User name for User' }] }]"
            placeholder="What is this permission about"
            :autosize="{ minRows: 2, maxRows: 12 }"
          />
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <div class="ant-modal-footer" style="padding-right:0">
          <div>
            <button @click="onCancel" type="button" class="ant-btn">
              <span>Cancel</span>
            </button>
            <button type="submit" class="ant-btn ant-btn-primary">
              <span>Create</span>
            </button>
          </div>
        </div>
      </a-col>
    </a-form>
  </div>
</template>


<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {
      visible: true,
      form: this.$form.createForm(this, { name: "coordinated" }),
      slug: "",
      services: [
        { name: "Billing Service", alias: 'billing', id: 1 },
        { name: "Time Tracking", alias: 'time-tracking', id: 2 },
        { name: "SSO", alias: 'sso', id: 3 }
      ]
    };
  },
  props: ["permission"],
  methods: {
    addPermission(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const hide = this.$message.loading(
            "Saving Permissions - Please hold on"
          );
          let data = {
            id: this.permission && this.permission.id,
            name: values.name.split(" ").join("-"),
            service: values.service,
            description: values.description,
            active: values.status
          };

          this.$store
            .dispatch("addPermission", data)
            .then(s => {
              if (s) {
                setTimeout(hide, 20);
                this.$message.success("🔏 Permission Successfully Saved");
                return this.$router.push({ name: "permissions" });
              }
            })
            .catch(err => {
              if (err.status === 422) {
                setTimeout(hide, 20);
                Object.values(err.data).forEach(s => {
                  this.$message.error("Sorry, " + s, 2.5);
                });
              }
            });
        }
      });
    },
    onCancel(e) {
      return this.$router.push({ name: "permissions" });
    },
    setSlug(e) {
      //this.slug = e.split(" ").join("-");
    }
  }
};
</script>
